import { Component, inject, input, OnDestroy, output, signal } from '@angular/core';
import { AudioService } from '@core/audio/audio.service';
import { SpeechSynthesisService } from '@core/audio/speech-synthesis.service';

@Component({
  selector: 'wk8-audio-button',
  imports: [],
  templateUrl: './wk8-audio-button.component.html',
  styleUrl: './wk8-audio-button.component.css',
})
export class Wk8AudioButtonComponent implements OnDestroy {
  readonly #audioService = inject(AudioService);
  readonly #speechSynthesisService = inject(SpeechSynthesisService);

  audio = input<string>();
  cc = input<string>();
  played = output<void>();

  waves = signal<number[]>([]);

  isDestroyed = false;
  ngOnDestroy(): void {
    this.isDestroyed = true;
  }

  async play(audio?: string, cc?: string) {
    this.waves.set([...this.waves(), 1]);
    const audioUrl = audio ?? this.audio();
    const ccText = cc ?? this.cc();
    if (audioUrl) {
      await this.#audioService.play(audioUrl).waitForEnd();
    } else if (ccText) {
      await this.#speechSynthesisService.speakSentenceAsync(ccText);
    }

    if (this.isDestroyed) return;

    this.played.emit();
  }
}
